
import sanitizeHtml from 'sanitize-html';
import { Component, namespace, Watch, Vue } from 'nuxt-property-decorator';
import { BeforeUnloadModal } from 'fourwaves-shared/components';
import Navigation from '~/components/navigation/Navigation.vue';
import UpgradeCheckout from '~/components/upgrade/UpgradeCheckout.vue';

const EventsModule = namespace('events');

@Component({
  components: {
    Navigation,
    BeforeUnloadModal,
    UpgradeCheckout,
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
})
export default class App extends Vue {
  @EventsModule.State timeZone!: string;

  @Watch('timeZone')
  onTimeZoneChanged() {
    this.$moment.tz.setDefault(this.timeZone);
  }

  created() {
    this.$moment.locale(this.$i18n.locale);
    this.onTimeZoneChanged();
  }

  mounted() {
    if (this.$route && this.$route.query && this.$route.query.tmsg) {
      const message = sanitizeHtml(this.$t(this.$route.query.tmsg as string));
      this.$toast.success(message);

      if (!this.$route.query.redirect) {
        const query = Object.assign({}, this.$route.query);
        delete query.tmsg;
        this.$router.replace({ query });
      }
    }
  }
}
